// Small, dependency-free GIF89a encoder with a fixed 3-3-2 RGB palette.
const palette = Array.from({ length: 256 }, (_, index) => [
  Math.round(((index >> 5) & 7) * 255 / 7),
  Math.round(((index >> 2) & 7) * 255 / 7),
  Math.round((index & 3) * 255 / 3),
]).flat();

function lzw(pixels) {
  const clear = 256;
  const end = 257;
  let dictionary = new Map();
  let next = 258;
  let width = 9;
  let bits = 0;
  let count = 0;
  const bytes = [];
  const write = (code) => {
    bits |= code << count;
    count += width;
    while (count >= 8) {
      bytes.push(bits & 255);
      bits >>>= 8;
      count -= 8;
    }
  };
  write(clear);
  let previous = pixels[0];
  for (let i = 1; i < pixels.length; i += 1) {
    const value = pixels[i];
    const key = previous * 256 + value;
    if (dictionary.has(key)) {
      previous = dictionary.get(key);
    } else {
      write(previous);
      if (next < 4096) {
        dictionary.set(key, next++);
        if (next > (1 << width) && width < 12) width += 1;
      } else {
        write(clear);
        dictionary = new Map();
        next = 258;
        width = 9;
      }
      previous = value;
    }
  }
  write(previous);
  write(end);
  if (count) bytes.push(bits & 255);
  return bytes;
}

export function encodeGif(frames, width, height, delay = 70) {
  const bytes = [];
  const word = (value) => { bytes.push(value & 255, (value >> 8) & 255); };
  bytes.push(...[..."GIF89a"].map((char) => char.charCodeAt(0)));
  word(width); word(height);
  bytes.push(0xf7, 0, 0, ...palette);
  // Loop indefinitely.
  bytes.push(0x21, 0xff, 11, ...[..."NETSCAPE2.0"].map((char) => char.charCodeAt(0)), 3, 1, 0, 0, 0);
  frames.forEach((image) => {
    bytes.push(0x21, 0xf9, 4, 0, delay & 255, (delay >> 8) & 255, 0, 0);
    bytes.push(0x2c); word(0); word(0); word(width); word(height); bytes.push(0);
    const rgba = image.data;
    const pixels = new Uint8Array(width * height);
    for (let i = 0; i < pixels.length; i += 1) {
      const at = i * 4;
      pixels[i] = (rgba[at] & 0xe0) | ((rgba[at + 1] & 0xe0) >> 3) | (rgba[at + 2] >> 6);
    }
    const data = lzw(pixels);
    bytes.push(8);
    for (let i = 0; i < data.length; i += 255) bytes.push(Math.min(255, data.length - i), ...data.slice(i, i + 255));
    bytes.push(0);
  });
  bytes.push(0x3b);
  return new Blob([new Uint8Array(bytes)], { type: "image/gif" });
}
